// @core/stores/calendar/CalendarAvailabilityStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { calendarApi } from '@core/api';
import type {
  FindAvailableSlotsRequest,
  FindAvailableSlotsResponse,
  GetFreeBusyRequest,
  GetFreeBusyResponse,
  SetWorkingHoursRequest,
  WorkingHoursResponse,
} from '@core/types/calendar';

class CalendarAvailabilityStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Find available slots
   */
  async FindAvailableSlots(data: FindAvailableSlotsRequest): Promise<FindAvailableSlotsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await calendarApi.FindAvailableSlots(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get free/busy
   */
  async GetFreeBusy(data: GetFreeBusyRequest): Promise<GetFreeBusyResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await calendarApi.GetFreeBusy(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get working hours
   */
  async GetWorkingHours(actor_id: string): Promise<WorkingHoursResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await calendarApi.GetWorkingHours(actor_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Set working hours
   */
  async SetWorkingHours(data: SetWorkingHoursRequest): Promise<WorkingHoursResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await calendarApi.SetWorkingHours(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const calendarAvailabilityStore = new CalendarAvailabilityStore();
